var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.pageLoading,
          expression: "pageLoading",
        },
      ],
      staticClass: "add-inkhub-monthly",
    },
    [
      _c(
        "div",
        { staticClass: "blocks-section" },
        [
          _c(
            "div",
            { staticClass: "blocks-section-header" },
            [
              _c("span", { staticClass: "blocks-section-title" }, [
                _vm._v("\n        语言板块\n        "),
                _vm.editPeriod
                  ? _c("em", { staticClass: "period-tip" }, [
                      _vm._v("期数：" + _vm._s(_vm.editPeriod)),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    plain: "",
                    size: "small",
                    icon: "el-icon-plus",
                  },
                  on: { click: _vm.addBlock },
                },
                [_vm._v("\n        添加板块\n      ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.blocks, function (block, index) {
            return _c(
              "div",
              {
                key: block.id != null ? "id-" + block.id : "new-" + index,
                staticClass: "block-item",
              },
              [
                _c(
                  "div",
                  { staticClass: "block-header" },
                  [
                    _c("span", { staticClass: "block-title" }, [
                      _vm._v("板块 " + _vm._s(index + 1)),
                    ]),
                    _vm._v(" "),
                    _vm.canRemoveBlock(block)
                      ? _c(
                          "el-button",
                          {
                            staticClass: "remove-btn",
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.removeBlock(index)
                              },
                            },
                          },
                          [_vm._v("删除板块")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "blockForm" + index,
                    refInFor: true,
                    attrs: {
                      model: block,
                      rules: _vm.blockRules,
                      "label-width": _vm.formLabelWidth,
                      "status-icon": true,
                      "show-message": false,
                      "hide-required-asterisk": "",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "语言", prop: "language" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: "请选择",
                              disabled: block.id != null && block.id !== "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.onLanguageChange(index)
                              },
                            },
                            model: {
                              value: block.language,
                              callback: function ($$v) {
                                _vm.$set(block, "language", $$v)
                              },
                              expression: "block.language",
                            },
                          },
                          _vm._l(_vm.type, function (item, i) {
                            return _c("el-option", {
                              key: i,
                              attrs: {
                                label: item.valueCn,
                                value: item.valueCn,
                                disabled: _vm.isLanguageUsed(
                                  item.valueCn,
                                  index
                                ),
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "网页标题", prop: "theme" } },
                      [
                        _c("el-input", {
                          attrs: {
                            autocomplete: "off",
                            type: "text",
                            maxlength: "255",
                            placeholder: "请输入网页标题",
                          },
                          model: {
                            value: block.theme,
                            callback: function ($$v) {
                              _vm.$set(block, "theme", $$v)
                            },
                            expression: "block.theme",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "banner上传", prop: "bannerUrl" } },
                      [
                        _c(
                          "div",
                          { staticClass: "banner-box" },
                          [
                            !block.bannerPreview
                              ? _c(
                                  "el-upload",
                                  {
                                    staticClass: "avatar-uploader",
                                    attrs: {
                                      action:
                                        "https://jsonplaceholder.typicode.com/posts/",
                                      accept: "image/*",
                                      "show-file-list": false,
                                      "before-upload": function (file) {
                                        return _vm.beforeUploadBanner(
                                          file,
                                          index
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-plus avatar-uploader-icon",
                                    }),
                                  ]
                                )
                              : [
                                  _c("img", {
                                    staticClass: "avatar",
                                    attrs: {
                                      src: block.bannerPreview,
                                      alt: "banner",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.previewBanner(
                                          block.bannerPreview
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "preview-actions" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "preview-tip" },
                                        [_vm._v("点击图片放大查看")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-upload",
                                        {
                                          staticClass: "reupload",
                                          attrs: {
                                            action:
                                              "https://jsonplaceholder.typicode.com/posts/",
                                            accept: "image/*",
                                            "show-file-list": false,
                                            "before-upload": function (file) {
                                              return _vm.beforeUploadBanner(
                                                file,
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            { attrs: { type: "text" } },
                                            [_vm._v("更换图片")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                          ],
                          2
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "文章上传", prop: "articleUrl" } },
                      [
                        _c(
                          "div",
                          { staticClass: "upload-wrapper" },
                          [
                            _c("input", {
                              ref: "articleUpload" + index,
                              refInFor: true,
                              staticClass: "upload-file",
                              attrs: {
                                type: "file",
                                accept: ".html,.htm,text/html",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.submitArticleUpload(index)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: block.articleLoading,
                                    expression: "block.articleLoading",
                                  },
                                ],
                                attrs: { size: "small", type: "primary" },
                              },
                              [
                                _vm._v(
                                  _vm._s(block.articleUrl ? "重新上传" : "上传")
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        block.articleUrl
                          ? _c(
                              "div",
                              {
                                staticClass: "url-text",
                                attrs: { title: block.articleUrl },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(block.articleUrl) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        block.articleUrl
                          ? _c("div", { staticClass: "article-link" }, [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: block.articleUrl,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                  },
                                },
                                [_vm._v("预览文章")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticStyle: { "margin-left": "16px" },
                                  attrs: { href: "javascript:;" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.downloadArticle(
                                        block.articleUrl
                                      )
                                    },
                                  },
                                },
                                [_vm._v("下载")]
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "submit-bar" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: _vm.isDisable },
              on: { click: _vm.submit },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Banner预览",
            visible: _vm.bannerDialogVisible,
            width: "720px",
            "append-to-body": "",
            "custom-class": "inkhub-banner-preview-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.bannerDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "banner-preview-wrap" }, [
            _c("img", {
              staticClass: "banner-preview-img",
              attrs: { src: _vm.dialogBannerUrl, alt: "banner preview" },
            }),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }